module.exports = __webpack_public_path__ + "img/caminhao-azul.dde68201.png";